import { useContext, useMemo } from 'react'

import GeoContext from 'contexts/geoContext'
import { useAppSelector } from 'hooks/reduxHooks'
import { getLabRequestAttributes, getLabModalPopupsRequestKey } from 'lib/lab/labRequestContext'
import { removeRegionCode } from 'lib/string/regionUtils'

/**
 * Inputs shared by Lab surfaces that fetch by region-stripped path and user identity.
 */
export function useLabRouteRequestContext() {
  const { currentRegionCode } = useContext(GeoContext)
  const pathname = useAppSelector(state => state.router.location.pathname)
  const distinctId = useAppSelector(state => state.auth.domainUserId ?? 'anonymous')
  const token = useAppSelector(state => state.auth.accessToken)
  const currentPath = useMemo(
    () => removeRegionCode(pathname, currentRegionCode),
    [pathname, currentRegionCode],
  )

  return {
    currentPath,
    pathname,
    currentRegionCode,
    distinctId,
    token,
  }
}

export function useLabModalPopupsRequestContext() {
  const routeRequestContext = useLabRouteRequestContext()
  const labRequestContextKey = useAppSelector(state => getLabModalPopupsRequestKey({
    currentPath: routeRequestContext.currentPath,
    distinctId: routeRequestContext.distinctId,
    hasToken: Boolean(routeRequestContext.token),
    featureFlagContext: state.system.features.context,
    labRequestAttributes: getLabRequestAttributes(state),
  }))

  return {
    ...routeRequestContext,
    labRequestContextKey,
  }
}
